"use strict";

var _excluded = ["transform", "origin", "originX", "originY", "fontFamily", "fontSize", "fontWeight", "fontStyle", "style", "forwardedRef", "gradientTransform", "patternTransform"],
  _excluded2 = ["x", "y"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WebShape = exports.Use = exports.TextPath = exports.Text = exports.TSpan = exports.Symbol = exports.Svg = exports.Stop = exports.Rect = exports.RadialGradient = exports.Polyline = exports.Polygon = exports.Pattern = exports.Path = exports.Mask = exports.Marker = exports.LinearGradient = exports.Line = exports.Image = exports.G = exports.ForeignObject = exports.Ellipse = exports.Defs = exports.ClipPath = exports.Circle = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _SvgTouchableMixin = _interopRequireDefault(require("./lib/SvgTouchableMixin"));
var _resolve = require("./lib/resolve");
var _extractTransform = require("./lib/extract/extractTransform");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var createElement = _reactNative.createElement || _reactNative.unstable_createElement;
var hasTouchableProperty = function hasTouchableProperty(props) {
  return props.onPress || props.onPressIn || props.onPressOut || props.onLongPress;
};
var camelCaseToDashed = function camelCaseToDashed(camelCase) {
  return camelCase.replace(/[A-Z]/g, function (m) {
    return '-' + m.toLowerCase();
  });
};
function stringifyTransformProps(transformProps) {
  var transformArray = [];
  if (transformProps.translate != null) {
    transformArray.push("translate(".concat(transformProps.translate, ")"));
  }
  if (transformProps.translateX != null || transformProps.translateY != null) {
    transformArray.push("translate(".concat(transformProps.translateX || 0, ", ").concat(transformProps.translateY || 0, ")"));
  }
  if (transformProps.scale != null) {
    transformArray.push("scale(".concat(transformProps.scale, ")"));
  }
  if (transformProps.scaleX != null || transformProps.scaleY != null) {
    transformArray.push("scale(".concat(transformProps.scaleX || 1, ", ").concat(transformProps.scaleY || 1, ")"));
  }
  // rotation maps to rotate, not to collide with the text rotate attribute (which acts per glyph rather than block)
  if (transformProps.rotation != null) {
    transformArray.push("rotate(".concat(transformProps.rotation, ")"));
  }
  if (transformProps.skewX != null) {
    transformArray.push("skewX(".concat(transformProps.skewX, ")"));
  }
  if (transformProps.skewY != null) {
    transformArray.push("skewY(".concat(transformProps.skewY, ")"));
  }
  return transformArray;
}
function parseTransformProp(transform, props) {
  var transformArray = [];
  props && transformArray.push.apply(transformArray, _toConsumableArray(stringifyTransformProps(props)));
  if (Array.isArray(transform)) {
    if (typeof transform[0] === 'number') {
      transformArray.push("matrix(".concat(transform.join(' '), ")"));
    } else {
      var stringifiedProps = (0, _extractTransform.transformsArrayToProps)(transform);
      transformArray.push.apply(transformArray, _toConsumableArray(stringifyTransformProps(stringifiedProps)));
    }
  } else if (typeof transform === 'string') {
    transformArray.push(transform);
  }
  return transformArray.length ? transformArray.join(' ') : undefined;
}

/**
 * `react-native-svg` supports additional props that aren't defined in the spec.
 * This function replaces them in a spec conforming manner.
 *
 * @param {WebShape} self Instance given to us.
 * @param {Object?} props Optional overridden props given to us.
 * @returns {Object} Cleaned props object.
 * @private
 */
var prepare = function prepare(self) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.props;
  var transform = props.transform,
    origin = props.origin,
    originX = props.originX,
    originY = props.originY,
    fontFamily = props.fontFamily,
    fontSize = props.fontSize,
    fontWeight = props.fontWeight,
    fontStyle = props.fontStyle,
    style = props.style,
    forwardedRef = props.forwardedRef,
    gradientTransform = props.gradientTransform,
    patternTransform = props.patternTransform,
    rest = _objectWithoutProperties(props, _excluded);
  var clean = _objectSpread(_objectSpread({}, hasTouchableProperty(props) ? {
    onStartShouldSetResponder: self.touchableHandleStartShouldSetResponder,
    onResponderTerminationRequest: self.touchableHandleResponderTerminationRequest,
    onResponderGrant: self.touchableHandleResponderGrant,
    onResponderMove: self.touchableHandleResponderMove,
    onResponderRelease: self.touchableHandleResponderRelease,
    onResponderTerminate: self.touchableHandleResponderTerminate
  } : null), rest);
  if (origin != null) {
    clean['transform-origin'] = origin.toString().replace(',', ' ');
  } else if (originX != null || originY != null) {
    clean['transform-origin'] = "".concat(originX || 0, " ").concat(originY || 0);
  }
  clean.transform = parseTransformProp(transform, props);
  clean.gradientTransform = parseTransformProp(gradientTransform);
  clean.patternTransform = parseTransformProp(patternTransform);
  clean.ref = function (el) {
    self.elementRef.current = el;
    if (typeof forwardedRef === 'function') {
      forwardedRef(el);
    } else if (forwardedRef) {
      forwardedRef.current = el;
    }
  };
  var styles = {};
  if (fontFamily != null) {
    styles.fontFamily = fontFamily;
  }
  if (fontSize != null) {
    styles.fontSize = fontSize;
  }
  if (fontWeight != null) {
    styles.fontWeight = fontWeight;
  }
  if (fontStyle != null) {
    styles.fontStyle = fontStyle;
  }
  clean.style = (0, _resolve.resolve)(style, styles);
  return clean;
};
var getBoundingClientRect = function getBoundingClientRect(node) {
  if (node) {
    // @ts-ignore
    var isElement = node.nodeType === 1; /* Node.ELEMENT_NODE */
    // @ts-ignore
    if (isElement && typeof node.getBoundingClientRect === 'function') {
      // @ts-ignore
      return node.getBoundingClientRect();
    }
  }
};
var measureLayout = function measureLayout(node, callback) {
  // @ts-ignore
  var relativeNode = node && node.parentNode;
  if (relativeNode) {
    setTimeout(function () {
      // @ts-ignore
      var relativeRect = getBoundingClientRect(relativeNode);
      var _getBoundingClientRec = getBoundingClientRect(node),
        height = _getBoundingClientRec.height,
        left = _getBoundingClientRec.left,
        top = _getBoundingClientRec.top,
        width = _getBoundingClientRec.width;
      var x = left - relativeRect.left;
      var y = top - relativeRect.top;
      callback(x, y, width, height, left, top);
    }, 0);
  }
};
function remeasure() {
  // @ts-ignore
  var tag = this.state.touchable.responderID;
  if (tag == null) {
    return;
  }
  // @ts-ignore
  measureLayout(tag, this._handleQueryLayout);
}
var WebShape = /*#__PURE__*/function (_React$Component) {
  _inherits(WebShape, _React$Component);
  function WebShape(props, context) {
    var _this;
    _classCallCheck(this, WebShape);
    _this = _callSuper(this, WebShape, [props, context]);

    // Do not attach touchable mixin handlers if SVG element doesn't have a touchable prop
    _this.elementRef = /*#__PURE__*/React.createRef();
    _this.lastMergedProps = {};
    if (hasTouchableProperty(props)) {
      (0, _SvgTouchableMixin["default"])(_assertThisInitialized(_this));
    }
    _this._remeasureMetricsOnActivation = remeasure.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(WebShape, [{
    key: "prepareProps",
    value: function prepareProps(props) {
      return props;
    }
  }, {
    key: "setNativeProps",
    value:
    /**
     * disclaimer: I am not sure why the props are wrapped in a `style` attribute here, but that's how reanimated calls it
     */
    function setNativeProps(props) {
      var _clean$style;
      var merged = Object.assign({}, this.props, this.lastMergedProps, props.style);
      this.lastMergedProps = merged;
      var clean = prepare(this, this.prepareProps(merged));
      var current = this.elementRef.current;
      if (current) {
        for (var _i = 0, _Object$keys = Object.keys(clean); _i < _Object$keys.length; _i++) {
          var cleanAttribute = _Object$keys[_i];
          var cleanValue = clean[cleanAttribute];
          switch (cleanAttribute) {
            case 'ref':
            case 'children':
              break;
            case 'style':
              // style can be an object here or an array, so we convert it to an array and assign each element
              var _iterator = _createForOfIteratorHelper([].concat((_clean$style = clean.style) !== null && _clean$style !== void 0 ? _clean$style : [])),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var partialStyle = _step.value;
                  // @ts-expect-error "DOM" is not part of `compilerOptions.lib`
                  Object.assign(current.style, partialStyle);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              break;
            default:
              // apply all other incoming prop updates as attributes on the node
              // same logic as in https://github.com/software-mansion/react-native-reanimated/blob/d04720c82f5941532991b235787285d36d717247/src/reanimated2/js-reanimated/index.ts#L38-L39
              // @ts-expect-error "DOM" is not part of `compilerOptions.lib`
              current.setAttribute(camelCaseToDashed(cleanAttribute), cleanValue);
              break;
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.tag) {
        throw new Error('When extending `WebShape` you need to overwrite either `tag` or `render`!');
      }
      this.lastMergedProps = {};
      return createElement(this.tag, prepare(this, this.prepareProps(this.props)));
    }
  }]);
  return WebShape;
}(React.Component);
exports.WebShape = WebShape;
var Circle = /*#__PURE__*/function (_WebShape) {
  _inherits(Circle, _WebShape);
  function Circle() {
    var _this2;
    _classCallCheck(this, Circle);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, Circle, [].concat(args));
    _this2.tag = 'circle';
    return _this2;
  }
  return _createClass(Circle);
}(WebShape);
exports.Circle = Circle;
var ClipPath = /*#__PURE__*/function (_WebShape2) {
  _inherits(ClipPath, _WebShape2);
  function ClipPath() {
    var _this3;
    _classCallCheck(this, ClipPath);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this3 = _callSuper(this, ClipPath, [].concat(args));
    _this3.tag = 'clipPath';
    return _this3;
  }
  return _createClass(ClipPath);
}(WebShape);
exports.ClipPath = ClipPath;
var Defs = /*#__PURE__*/function (_WebShape3) {
  _inherits(Defs, _WebShape3);
  function Defs() {
    var _this4;
    _classCallCheck(this, Defs);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this4 = _callSuper(this, Defs, [].concat(args));
    _this4.tag = 'defs';
    return _this4;
  }
  return _createClass(Defs);
}(WebShape);
exports.Defs = Defs;
var Ellipse = /*#__PURE__*/function (_WebShape4) {
  _inherits(Ellipse, _WebShape4);
  function Ellipse() {
    var _this5;
    _classCallCheck(this, Ellipse);
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    _this5 = _callSuper(this, Ellipse, [].concat(args));
    _this5.tag = 'ellipse';
    return _this5;
  }
  return _createClass(Ellipse);
}(WebShape);
exports.Ellipse = Ellipse;
var G = /*#__PURE__*/function (_WebShape5) {
  _inherits(G, _WebShape5);
  function G() {
    var _this6;
    _classCallCheck(this, G);
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    _this6 = _callSuper(this, G, [].concat(args));
    _this6.tag = 'g';
    return _this6;
  }
  _createClass(G, [{
    key: "prepareProps",
    value: function prepareProps(props) {
      var x = props.x,
        y = props.y,
        rest = _objectWithoutProperties(props, _excluded2);
      if ((x || y) && !rest.translate) {
        rest.translate = "".concat(x || 0, ", ").concat(y || 0);
      }
      return rest;
    }
  }]);
  return G;
}(WebShape);
exports.G = G;
var Image = /*#__PURE__*/function (_WebShape6) {
  _inherits(Image, _WebShape6);
  function Image() {
    var _this7;
    _classCallCheck(this, Image);
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }
    _this7 = _callSuper(this, Image, [].concat(args));
    _this7.tag = 'image';
    return _this7;
  }
  return _createClass(Image);
}(WebShape);
exports.Image = Image;
var Line = /*#__PURE__*/function (_WebShape7) {
  _inherits(Line, _WebShape7);
  function Line() {
    var _this8;
    _classCallCheck(this, Line);
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }
    _this8 = _callSuper(this, Line, [].concat(args));
    _this8.tag = 'line';
    return _this8;
  }
  return _createClass(Line);
}(WebShape);
exports.Line = Line;
var LinearGradient = /*#__PURE__*/function (_WebShape8) {
  _inherits(LinearGradient, _WebShape8);
  function LinearGradient() {
    var _this9;
    _classCallCheck(this, LinearGradient);
    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }
    _this9 = _callSuper(this, LinearGradient, [].concat(args));
    _this9.tag = 'linearGradient';
    return _this9;
  }
  return _createClass(LinearGradient);
}(WebShape);
exports.LinearGradient = LinearGradient;
var Path = /*#__PURE__*/function (_WebShape9) {
  _inherits(Path, _WebShape9);
  function Path() {
    var _this10;
    _classCallCheck(this, Path);
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }
    _this10 = _callSuper(this, Path, [].concat(args));
    _this10.tag = 'path';
    return _this10;
  }
  return _createClass(Path);
}(WebShape);
exports.Path = Path;
var Polygon = /*#__PURE__*/function (_WebShape10) {
  _inherits(Polygon, _WebShape10);
  function Polygon() {
    var _this11;
    _classCallCheck(this, Polygon);
    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }
    _this11 = _callSuper(this, Polygon, [].concat(args));
    _this11.tag = 'polygon';
    return _this11;
  }
  return _createClass(Polygon);
}(WebShape);
exports.Polygon = Polygon;
var Polyline = /*#__PURE__*/function (_WebShape11) {
  _inherits(Polyline, _WebShape11);
  function Polyline() {
    var _this12;
    _classCallCheck(this, Polyline);
    for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }
    _this12 = _callSuper(this, Polyline, [].concat(args));
    _this12.tag = 'polyline';
    return _this12;
  }
  return _createClass(Polyline);
}(WebShape);
exports.Polyline = Polyline;
var RadialGradient = /*#__PURE__*/function (_WebShape12) {
  _inherits(RadialGradient, _WebShape12);
  function RadialGradient() {
    var _this13;
    _classCallCheck(this, RadialGradient);
    for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      args[_key12] = arguments[_key12];
    }
    _this13 = _callSuper(this, RadialGradient, [].concat(args));
    _this13.tag = 'radialGradient';
    return _this13;
  }
  return _createClass(RadialGradient);
}(WebShape);
exports.RadialGradient = RadialGradient;
var Rect = /*#__PURE__*/function (_WebShape13) {
  _inherits(Rect, _WebShape13);
  function Rect() {
    var _this14;
    _classCallCheck(this, Rect);
    for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      args[_key13] = arguments[_key13];
    }
    _this14 = _callSuper(this, Rect, [].concat(args));
    _this14.tag = 'rect';
    return _this14;
  }
  return _createClass(Rect);
}(WebShape);
exports.Rect = Rect;
var Stop = /*#__PURE__*/function (_WebShape14) {
  _inherits(Stop, _WebShape14);
  function Stop() {
    var _this15;
    _classCallCheck(this, Stop);
    for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
      args[_key14] = arguments[_key14];
    }
    _this15 = _callSuper(this, Stop, [].concat(args));
    _this15.tag = 'stop';
    return _this15;
  }
  return _createClass(Stop);
}(WebShape);
exports.Stop = Stop;
var Svg = /*#__PURE__*/function (_WebShape15) {
  _inherits(Svg, _WebShape15);
  function Svg() {
    var _this16;
    _classCallCheck(this, Svg);
    for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      args[_key15] = arguments[_key15];
    }
    _this16 = _callSuper(this, Svg, [].concat(args));
    _this16.tag = 'svg';
    return _this16;
  }
  return _createClass(Svg);
}(WebShape);
exports.Svg = Svg;
var _Symbol = /*#__PURE__*/function (_WebShape16) {
  _inherits(_Symbol, _WebShape16);
  function _Symbol() {
    var _this17;
    _classCallCheck(this, _Symbol);
    for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      args[_key16] = arguments[_key16];
    }
    _this17 = _callSuper(this, _Symbol, [].concat(args));
    _this17.tag = 'symbol';
    return _this17;
  }
  return _createClass(_Symbol);
}(WebShape);
exports.Symbol = _Symbol;
var Text = /*#__PURE__*/function (_WebShape17) {
  _inherits(Text, _WebShape17);
  function Text() {
    var _this18;
    _classCallCheck(this, Text);
    for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
      args[_key17] = arguments[_key17];
    }
    _this18 = _callSuper(this, Text, [].concat(args));
    _this18.tag = 'text';
    return _this18;
  }
  return _createClass(Text);
}(WebShape);
exports.Text = Text;
var TSpan = /*#__PURE__*/function (_WebShape18) {
  _inherits(TSpan, _WebShape18);
  function TSpan() {
    var _this19;
    _classCallCheck(this, TSpan);
    for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
      args[_key18] = arguments[_key18];
    }
    _this19 = _callSuper(this, TSpan, [].concat(args));
    _this19.tag = 'tspan';
    return _this19;
  }
  return _createClass(TSpan);
}(WebShape);
exports.TSpan = TSpan;
var TextPath = /*#__PURE__*/function (_WebShape19) {
  _inherits(TextPath, _WebShape19);
  function TextPath() {
    var _this20;
    _classCallCheck(this, TextPath);
    for (var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
      args[_key19] = arguments[_key19];
    }
    _this20 = _callSuper(this, TextPath, [].concat(args));
    _this20.tag = 'textPath';
    return _this20;
  }
  return _createClass(TextPath);
}(WebShape);
exports.TextPath = TextPath;
var Use = /*#__PURE__*/function (_WebShape20) {
  _inherits(Use, _WebShape20);
  function Use() {
    var _this21;
    _classCallCheck(this, Use);
    for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
      args[_key20] = arguments[_key20];
    }
    _this21 = _callSuper(this, Use, [].concat(args));
    _this21.tag = 'use';
    return _this21;
  }
  return _createClass(Use);
}(WebShape);
exports.Use = Use;
var Mask = /*#__PURE__*/function (_WebShape21) {
  _inherits(Mask, _WebShape21);
  function Mask() {
    var _this22;
    _classCallCheck(this, Mask);
    for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
      args[_key21] = arguments[_key21];
    }
    _this22 = _callSuper(this, Mask, [].concat(args));
    _this22.tag = 'mask';
    return _this22;
  }
  return _createClass(Mask);
}(WebShape);
exports.Mask = Mask;
var ForeignObject = /*#__PURE__*/function (_WebShape22) {
  _inherits(ForeignObject, _WebShape22);
  function ForeignObject() {
    var _this23;
    _classCallCheck(this, ForeignObject);
    for (var _len22 = arguments.length, args = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
      args[_key22] = arguments[_key22];
    }
    _this23 = _callSuper(this, ForeignObject, [].concat(args));
    _this23.tag = 'foreignObject';
    return _this23;
  }
  return _createClass(ForeignObject);
}(WebShape);
exports.ForeignObject = ForeignObject;
var Marker = /*#__PURE__*/function (_WebShape23) {
  _inherits(Marker, _WebShape23);
  function Marker() {
    var _this24;
    _classCallCheck(this, Marker);
    for (var _len23 = arguments.length, args = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
      args[_key23] = arguments[_key23];
    }
    _this24 = _callSuper(this, Marker, [].concat(args));
    _this24.tag = 'marker';
    return _this24;
  }
  return _createClass(Marker);
}(WebShape);
exports.Marker = Marker;
var Pattern = /*#__PURE__*/function (_WebShape24) {
  _inherits(Pattern, _WebShape24);
  function Pattern() {
    var _this25;
    _classCallCheck(this, Pattern);
    for (var _len24 = arguments.length, args = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
      args[_key24] = arguments[_key24];
    }
    _this25 = _callSuper(this, Pattern, [].concat(args));
    _this25.tag = 'pattern';
    return _this25;
  }
  return _createClass(Pattern);
}(WebShape);
exports.Pattern = Pattern;
var _default = Svg;
exports["default"] = _default;